import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { RackTrayRefDto, CabinetShelfRefDto } from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-racktrayref-container',
  templateUrl: './racktrayref-container.component.html',
  styleUrls: ['./racktrayref-container.component.scss']
})
export class RackTrayRefContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  cabinetshelfrefs$: Observable<CabinetShelfRefDto[]>;
  racktrayrefs$: Observable<RackTrayRefDto[]>;
  loading: boolean;
  isLoadingCabinetShelfRef$: Observable<boolean>;
  isLoadingRackTrayRef$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingCabinetShelfRef$ = this.gatwayFacade.isLoadingGateway("CabinetShelfRef");
    this.isLoadingRackTrayRef$ = this.gatwayFacade.isLoadingGateway("RackTrayRef");

    this.cabinetshelfrefs$ = this.gatwayFacade.loadGateway("CabinetShelfRef");
    this.racktrayrefs$ = this.gatwayFacade.loadGateway("RackTrayRef");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteRackTrayRef(deletedValue: any) {
    this.gatwayFacade.remove("RackTrayRef", deletedValue);
  }

// this method control both the create and update
  onSubmitRackTrayRef(formValue: any) {
    const pullData = formValue.RackTrayRefs;

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllRackTrayRef = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllRackTrayRef.push(pullData[i]);
    }
  }

// check if the addAllCountry array is not empty, then dispatch the data to the store
   if(addAllRackTrayRef.length > 0) {
    this.gatwayFacade.add('RackTrayRef', addAllRackTrayRef);
   }

// dispatch update data to the store
   if(allUpdates.length > 0) {
    this.gatwayFacade.update('RackTrayRef', allUpdates, ['id']);
   }
  }


}
